import RestDay from '../../model/RestDay'
import AppIcon from '../icons/AppIcon'
import Button from '../primitives/Button'
import Overlay, { OverlayCard } from '../primitives/Overlay'
import Eyebrow from '../primitives/Eyebrow'
import PipRow from '../primitives/PipRow'
import styles from './RestDayOverlays.module.css'

interface RestDayConfirmProps {
  remaining: number
  onConfirm: () => void
  onCancel: () => void
}

export function RestDayConfirm({ remaining, onConfirm, onCancel }: RestDayConfirmProps) {
  const lockHours = Math.round(RestDay.getDurationMs() / (60 * 60 * 1000))

  return (
    <Overlay variant="backdrop" onClose={onCancel}>
      <OverlayCard>
        <div className={styles.icon}>
          <AppIcon icon="mdi:moon-waning-crescent" size={28} />
        </div>
        <div className={styles.title}>Take a rest day?</div>
        <p className={styles.body}>
          Recovery counts. Logging locks for <b>{lockHours} hours</b> while you rest. This uses{' '}
          <b>1 of your {remaining}</b> remaining rest days.
        </p>
        <div className={styles.btns}>
          <Button onClick={onConfirm}>Yes, I&apos;ve earned it</Button>
          <Button variant="ghost" onClick={onCancel}>
            Not yet
          </Button>
        </div>
      </OverlayCard>
    </Overlay>
  )
}

interface RestDaySuccessProps {
  remaining: number
  total: number
  used: number
  onDone: () => void
}

export function RestDaySuccess({ remaining, total, used, onDone }: RestDaySuccessProps) {
  return (
    <Overlay>
      <div className={styles.glow} />
      <div className={[styles.center, styles.content].join(' ')}>
        <div className={styles.moon}>
          <AppIcon icon="mdi:moon-waning-crescent" size={46} />
          <span className={[styles.star, styles.s1].join(' ')} />
          <span className={[styles.star, styles.s2].join(' ')} />
          <span className={[styles.star, styles.s3].join(' ')} />
        </div>
        <Eyebrow className={styles.eyebrow}>Rest day logged</Eyebrow>
        <div className={styles.headline}>Rest well.</div>
        <p className={styles.desc}>
          Recovery is part of the work. Logging pauses while you recharge — your team keeps rolling.
        </p>
        <div className={styles.pill}>
          <span className={styles.pillIcon}>
            <AppIcon icon="mdi:moon-waning-crescent" size={18} />
          </span>
          <span className={styles.pillText}>
            <b>{remaining} rest days</b> left this challenge
          </span>
          <PipRow total={total} used={used} />
        </div>
        <div className={styles.doneBtn}>
          <Button onClick={onDone}>Done</Button>
        </div>
      </div>
    </Overlay>
  )
}
